import React, { useContext } from 'react'
import { Spinner, View } from 'oio-react'
import { LAYOUT_BOX } from 'config/constants/ui'
import ObjectStatusBanner from 'src/sites/kits/Object/components/StatusBanner'
import ObjectViewAside from 'src/sites/kits/Object/components/ViewAside'
import ObjectViewEventHeader from 'src/sites/kits/Object/components/ViewEventHeader'
import ObjectViewHeader from 'src/sites/kits/Object/components/ViewHeader'
import ObjectViewNav from 'src/sites/kits/Object/components/ViewNav'
import { InitiativeHierarchyContext, withInitiativeHierarchyProvider }
   from 'src/sites/kits/Utils/InitiativeHierarchy'
import { useGlobalState } from 'src/sites/state'
import ObjectViewRoutes from './Routes'

const DynamicViewPage = () => {
   const { theme } = useGlobalState()
   const isBoxGL = theme.tmpGlobalLayout === LAYOUT_BOX

   const { initiative, initiativeLoading } = useContext(InitiativeHierarchyContext)
   if (initiativeLoading) {
      return (
         <View
            display="flex"
            justifyContent="center"
            alignItems="center"
            width="100%"
            height="100%"
            textAlign="center"
            padding="90px"
            borderRadius="6px">
            <Spinner color={theme.tmpContentTextColor} width="24px" height="24px" />
         </View>
      )
   }

   const hasPageNav = ['event', 'group', 'resource'].includes(initiative.class)
   const asideColumnWidth = isBoxGL ? '300px' : '27%'
   const contentPaddingRight = '30px[d] 40px[e-f]'
   const viewPaddingLeft = isBoxGL
      ? '20px[a-b] 60px[c] 120px[d] 60px[e-f]'
      : `
         ${theme.tmpViewportPaddingA}[a]
         ${theme.tmpViewportPaddingB}[b]
         ${theme.tmpViewportPaddingC}[c]
         ${theme.tmpViewportPaddingD}[d]
      `

   const viewPaddingRight = isBoxGL
      ? '20px[a-b] 60px[c] 120px[d] 60px[e-f]'
      : `
         ${theme.tmpViewportPaddingA}[a]
         ${theme.tmpViewportPaddingB}[b]
         ${theme.tmpViewportPaddingC}[c]
         ${theme.tmpViewportPaddingD}[d]
         0px[e-f]
      `

   return (
      <>
         <ObjectStatusBanner />
         <View
            paddingLeft={viewPaddingLeft}
            paddingRight={viewPaddingRight}>
            {hasPageNav && (
               <View
                  width="100%"
                  paddingTop="40px[a-b] 60px[c-f]"
                  borderBottom={`1px solid ${theme.tmpContentLineColor}`}>
                  {initiative.class === 'event' && <ObjectViewEventHeader />}
                  {['group', 'resource'].includes(initiative.class) && <ObjectViewHeader />}
                  <ObjectViewNav />
               </View>
            )}
            <View
               display="flex[d-f]"
               position="relative"
               float="left"
               width="100%"
               minHeight="100vh"
               paddingBottom="60px">
               {/* Primary Content */}
               <View
                  position="relative"
                  flex="0 0 auto"
                  width={isBoxGL
                     ? `100%[a-d] calc(100% - ${asideColumnWidth})[e-f]`
                     : `100%[a-c] calc(100% - ${asideColumnWidth})[d-f]`
                  }>
                  <ObjectViewRoutes
                     contentPaddingLeft="0px"
                     contentPaddingRight={contentPaddingRight}
                  />
               </View>
               {/* Right Aside Column */}
               <ObjectViewAside width={asideColumnWidth} />
            </View>
         </View>
      </>
   )
}

export default withInitiativeHierarchyProvider({ slugParam: 'initiativeSlug' })(DynamicViewPage)
